var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Yup from "yup";
let lastCheckValue = null;
let lastMobileNumber = null;
export const validateMobileNumberServerSide = (mobileNumber) => __awaiter(void 0, void 0, void 0, function* () {
    // Avoid a few server calls, do numbers shorter than 5 chars?
    if (mobileNumber.length < 5) {
        return false;
    }
    // Cache the result so we don't spam the server
    if (lastCheckValue !== null && lastMobileNumber == mobileNumber) {
        return lastCheckValue;
    }
    // Simulate a server call
    try {
        const response = yield fetch("/api/webshop/form-validation/mobile", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ mobile: mobileNumber }),
        });
        const data = yield response.json();
        lastCheckValue = data.isValid;
        lastMobileNumber = mobileNumber;
        return lastCheckValue;
    }
    catch (error) {
        return new Yup.ValidationError("Error validating mobile number");
    }
});
